<template>
  <div class="history container my-2">
    <BoxHistory v-for="item in items" :data="item" :key="item.lottoDate" />
  </div>
</template>
<script>
// import moment from '@/moment'
import LottoService from '@/services/lottoService'
import BoxHistory from './components/BoxHistory'

export default {
  components: {
    BoxHistory
  },
  data() {
    return {
      interval: null,
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    loadData() {
      LottoService.getHistories()
      .then((response)=>{
        if(response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.loadData()

    this.interval = setInterval(()=>{
      this.loadData()
    }, 35000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>
<style lang="scss" scoped>
.history {
  z-index: 5;
  padding-bottom: 20px;
}
</style>
